import React, { useEffect, useState } from "react";
import { useSkills } from "../resume/useResumeData";
import Modal from "../../ui/Modal";

const SkillsModal = ({ itemToEdit, onClose }) => {
    const { addSkill, updateSkill, isAdding, isUpdating } = useSkills();
    const [formData, setFormData] = useState({
        name: "",
        percentage: 50,
        category: "technical",
        ordering: 0,
    });

    useEffect(() => {
        if (itemToEdit) {
            setFormData({
                name: itemToEdit.name || "",
                percentage: itemToEdit.percentage || 50,
                category: itemToEdit.category || "technical",
                ordering: itemToEdit.ordering || 0,
            });
        }
    }, [itemToEdit]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (itemToEdit) {
            updateSkill(
                { id: itemToEdit.id, ...formData },
                { onSuccess: onClose }
            );
        } else {
            addSkill(formData, { onSuccess: onClose });
        }
    };

    const isLoading = isAdding || isUpdating;

    return (
        <Modal
            isLoading={isLoading}
            onClose={onClose}
            title={itemToEdit ? "Edit Skill" : "Add Skill"}
        >
            <form onSubmit={handleSubmit} className="space-y-6 font-primary text-white">
                <div className="space-y-6">
                    <div>
                        <label className="mb-2 block text-sm font-medium text-stone-300">Skill Name</label>
                        <input
                            type="text"
                            required
                            className="h-12 w-full rounded-lg border-transparent bg-transparent p-4 shadow-xl outline-none placeholder:text-stone-400 focus:border-2 focus:border-primary"
                            value={formData.name}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                            placeholder="e.g. React.js"
                        />
                    </div>

                    <div>
                        <div className="flex justify-between mb-2">
                            <label className="block text-sm font-medium text-stone-300">Proficiency</label>
                            <span className="text-sm text-primary">{formData.percentage}%</span>
                        </div>
                        <input
                            type="range"
                            min="0"
                            max="100"
                            required
                            className="h-2 w-full appearance-none rounded-lg bg-stone-700 accent-primary cursor-pointer"
                            value={formData.percentage}
                            onChange={(e) => setFormData({ ...formData, percentage: parseInt(e.target.value) })}
                        />
                    </div>

                    <div>
                        <label className="mb-2 block text-sm font-medium text-stone-300">Category</label>
                        <select
                            className="h-12 w-full rounded-lg border-none bg-black/20 p-4 shadow-xl outline-none text-stone-300"
                            value={formData.category}
                            onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                        >
                            <option value="technical" className="bg-slate-800 text-stone-300">Technical</option>
                            <option value="soft" className="bg-slate-800 text-stone-300">Soft Skill</option>
                            <option value="language" className="bg-slate-800 text-stone-300">Language</option>
                            <option value="tool" className="bg-slate-800 text-stone-300">Tool</option>
                        </select>
                    </div>
                </div>

                <div className="flex justify-end pt-4">
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="btn flex min-w-[8rem] items-center justify-center border-none bg-gradient-to-tr from-sky-600 to-cyan-400 py-3 font-semibold uppercase text-white shadow-lg hover:from-cyan-400 hover:to-sky-600 active:scale-95 disabled:opacity-50 transition-all rounded-lg"
                    >
                        {isLoading ? "Saving..." : (itemToEdit ? "Update Skill" : "Save Skill")}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default SkillsModal;
